import { useMemo, useState } from 'react';
import { HeaderItems, StyledHeaderV2 } from './style';
import { createGradientOrSolid } from 'utils';
import { HeaderV2Props } from './types';

export const HeaderV2: React.FC<HeaderV2Props> = ({
  backgroundColor,
  profilePicUrl,
  profilePicBorder,
  openLogoutModal,
  overrideStore,
  logoSize,
  logoPicUrl,
  logoBadgeUrl,
  fontFamily = undefined,
  preview = false,
}) => {
  const [picLoaded, setPicLoaded] = useState(false);

  const inlineStyle = useMemo(() => {
    return {
      fontFamily: `"${fontFamily}"`,
      backgroundImage: `linear-gradient(${backgroundColor.gradientDirection}, ${backgroundColor.colorOne} 0%, ${backgroundColor.colorTwo} 100%)`,
    };
  }, [fontFamily, backgroundColor]);

  return (
    <StyledHeaderV2
      backgroundImage={inlineStyle.backgroundImage}
      fontFamily={inlineStyle.fontFamily}
    >
      <HeaderItems>
        <div data-hide="true" className={`logo ${logoSize}`}>
          <img
            alt="logo"
            className="logo__main"
            onClick={(e) => {
              if (
                process.env.NODE_ENV === 'development' &&
                e.detail === 3 &&
                !preview
              ) {
                overrideStore();
              }
            }}
            src={logoPicUrl}
          />
          <img alt="logo_badge" className="logo__badge" src={logoBadgeUrl} />
        </div>

        <div data-hide="true" className="profileContainer">
          <div
            className="frame"
            style={{
              background: createGradientOrSolid(profilePicBorder),
            }}
          >
            <img
              alt="profile"
              src={profilePicUrl}
              onClick={openLogoutModal}
              style={{ display: picLoaded ? 'unset' : 'none' }}
              onLoad={() => setPicLoaded(true)}
            />
            <img
              alt="profile"
              onClick={openLogoutModal}
              src="https://media.appcharge.com/defaults/old-profile.png"
              style={{ display: picLoaded ? 'none' : 'unset' }}
            />
          </div>
        </div>
      </HeaderItems>
    </StyledHeaderV2>
  );
};
